/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useState, useEffect, useContext, useCallback } from "react";
import { Paper } from "@mui/material";
import { Suspense } from "react";
import { ContactDetails, ProfileDetails, ProfileHeader } from "..";
import ProfileEditDialog from "./profileDetails/profileEditDialog/ProfileEditDialog";
import ContactEditDialog from "./profileDetails/contactEditDialog/ContactEditDialog";
import ProfileSubHeader from "./profileSubHeader/ProfileSubHeader";
import { useHistory } from "react-router-dom";
import { AuthContext, GroupContext } from "../../../contexts";
import { Helmet } from "react-helmet";

import "./profile.css";
import { GROUP_NUMBER } from "../../../constants/groupNumber/groupNumber";

const Profile: React.FC = (): JSX.Element => {
	const [showProfileEditButton, setShowProfileEditButton] = useState(true);
	const [profileActionButtonsProps, setProfileActionButtonsProps] = useState([
		{
			title: "Edit",
			callback: () => setShowProfileEditButton(false)
		}
	]);
	const history = useHistory();
	const [contactActionButtonsProps, setContactActionButtonProps] = useState([
		{
			title: "Edit Contact",
			callback: () => history.push("/profile/add-contact")
		}
	]);
	const [editProfileDialogProps, setEditProfileDialogProps] = useState({
		openDialog: false,
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					setEditProfileDialogProps(Object.assign({}, editProfileDialogProps, { openDialog: false }));
				}
			}
			// },
			// {
			// 	label: "Submit",
			// 	name: "submit"
			// }
		]
	} as any);
	const [editContactDetailsDialogProps, setEditContactDetailsDialogProps] = useState({
		openDialog: false,
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					setEditContactDetailsDialogProps(
						Object.assign({}, editContactDetailsDialogProps, { openDialog: false })
					);
				}
			}
			// {
			// 	label: "Submit",
			// 	name: "submit"
			// }
		]
	} as any);
	const { member, setMember } = useContext(AuthContext);
	const { group } = useContext(GroupContext);
	const handleSaveProfileInformation = useCallback(async (): Promise<void> => {
		//api call here
		setShowProfileEditButton(true);
	}, []);

	const handleEditProfileDialogClose = useCallback(() => {
		setEditProfileDialogProps(Object.assign({}, editProfileDialogProps, { openDialog: false }));
	}, [editProfileDialogProps]);

	const handleOpenEditProfileDialog = useCallback(() => {
		setEditProfileDialogProps(Object.assign({}, editProfileDialogProps, { openDialog: true }));
	}, [editProfileDialogProps]);

	const handleOpenEditContactDialog = useCallback(() => {
		setEditContactDetailsDialogProps(Object.assign({}, editContactDetailsDialogProps, { openDialog: true }));
	}, [editContactDetailsDialogProps]);

	const handleEditContactDialogClose = useCallback(() => {
		setEditContactDetailsDialogProps(Object.assign({}, editContactDetailsDialogProps, { openDialog: false }));
	}, [editContactDetailsDialogProps]);

	useEffect((): void => {
		if (!showProfileEditButton) {
			setProfileActionButtonsProps(
				Object.assign(
					[],
					[
						{
							title: "Save",
							callback: handleSaveProfileInformation
						}
					]
				)
			);
		} else if (showProfileEditButton) {
			setProfileActionButtonsProps(
				Object.assign(
					[],
					[
						{
							title: "Edit Profile",
							callback: handleOpenEditProfileDialog
						}
					]
				)
			);
		}
	}, [handleOpenEditProfileDialog, handleSaveProfileInformation, showProfileEditButton]);

	useEffect((): void => {
		setContactActionButtonProps(
			Object.assign(
				[],
				[
					{
						title: "Edit Contact",
						callback: handleOpenEditContactDialog
					}
				]
			)
		);
	}, [handleOpenEditContactDialog]);

	return (
		<>
			<Suspense fallback={<div />}>
				<ProfileEditDialog
					dialogProps={editProfileDialogProps}
					handleClose={handleEditProfileDialogClose}
					member={member}
					setMember={setMember}
				/>
			</Suspense>
			<Suspense fallback={<div />}>
				<ContactEditDialog
					dialogProps={editContactDetailsDialogProps}
					handleClose={handleEditContactDialogClose}
					member={member}
					setMember={setMember}
				/>
			</Suspense>
			<div className="profile">
				{/* {member.group_number === GROUP_NUMBER.Brookshire_Brothers ? (
					<Helmet>
						<title>Brookshire Brothers - Profile</title>
					</Helmet>
				) : member.group_number === GROUP_NUMBER.Intercity_Investment ? (
					<Helmet>
						<title>Intercity Investments - Profile</title>
					</Helmet>
				) : member.group_number === GROUP_NUMBER.Intercity_Investment ? (
					<Helmet>
						<title>Panhandle First Bank - Profile</title>
					</Helmet>
				) : (
					<Helmet>
						<title>Nexcal Member Portal</title>
					</Helmet>
				)} */}
				<Paper elevation={1} className="theme-border-radius paper-container">
					{member && group ? (
						<>
							<Suspense fallback={<div />}>
								<ProfileHeader
									first_name={member.first_name}
									last_name={member.last_name}
									group_name={group.name}
								/>
							</Suspense>
							<Suspense fallback={<div />}>
								<ProfileSubHeader
									title={"Profile Information"}
									actionButtons={member?.role === "EMPLOYEE" ? profileActionButtonsProps : []}
								/>
							</Suspense>
							<Suspense fallback={<div />}>
								<ProfileDetails member={member} isInputDisabled={showProfileEditButton} />
								{/* <ProfileDetails
									SSN={member.SSN}
									date_of_birth={member.date_of_birth}
									gender={member.gender}
									member_id={member.member_id}
									marital_status={member.marital_status}
									isInputDisabled={showProfileEditButton}
								/> */}
							</Suspense>
							<Suspense fallback={<div />}>
								<ProfileSubHeader
									title={"Contact Information"}
									actionButtons={member?.role === "EMPLOYEE" ? contactActionButtonsProps : []}
								/>
							</Suspense>
							<Suspense fallback={<div />}>
								<ContactDetails member={member} />
								{/* <ContactDetails
									email={member?.email}
									address_line_1={member?.address_line_1}
									address_line_2={member?.address_line_2}
									city={member?.city}
									state={member?.state}
									country={member?.country}
									ZIP={member?.ZIP}
									contact_label={member?.contact_label}
									phone_number={member?.phone_number}
									phone_extension={member?.phone_extension}
								/> */}
							</Suspense>
						</>
					) : null}
				</Paper>
			</div>
		</>
	);
};

export default Profile;
